import { StyledContainer } from "components/home/styling";
import Head from "next/head";
import { useEffect } from "react";
import styled from "styled-components";

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const Team = () => {
  useEffect(() => {
    // Create a new script element
    const script = document.createElement("script");

    // Set the src attribute to the URL of the external script
    script.src = "https://testimonial.to/js/iframeResizer.min.js";

    // Set the type attribute
    script.type = "text/javascript";

    // Add an onload event listener to the script element
    script.onload = () => {
      // Call the iFrameResize function after the script loads
      window.iFrameResize(
        { log: false, checkOrigin: false },
        "#testimonialto-redact-dev-tag-all-dark",
      );
    };

    // Append the script element to the document head
    document.head.appendChild(script);
  }, []);
  return (
    <>
      <Head>
        <title>Redact - Testimonials</title>
        <meta charSet="utf-8" />
        <link rel="icon" href="/images/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="theme-color" content="#000000" />
        <meta name="robots" content="noarchive" />
        <meta
          name="description"
          content="Redact is a service that can easily mass delete your messages, posts, and comments on Twitter, Reddit, Discord, Facebook, and more."
        />
        <meta name="keywords" content="redact mass delete privacy free testimonials" />

        <meta property="og:title" content="Redact - Testimonials" />
        <meta
          property="og:description"
          content="HRedact is a service that can easily mass delete your messages, posts, and comments on Twitter, Reddit, Discord, Facebook, and more."
        />

        <meta property="og:url" content="https://www.redact.dev/testimonials" />
        <link rel="apple-touch-icon" href="images/logo192.png" />
      </Head>
      <StyledWrapper>
        <StyledContainer>
          <h1 className="hero__title" style={{ margin: "3rem 0" }}>
            Creating better privacy since 2020
          </h1>
          <iframe
            id="testimonialto-redact-dev-tag-all-dark"
            src="https://embed-v2.testimonial.to/w/redact-dev?theme=dark&card=base&loadMore=on&initialCount=20&tag=all"
            frameBorder="0"
            scrolling="no"
            width="100%"
          />
        </StyledContainer>
      </StyledWrapper>
    </>
  );
};

export default Team;
